import { string } from 'yup'
import { safify } from '../utils/safify'

export const topic = string()
  .required()
  .default('')
  .meta({
    placeholder: 'Try to be as detailed as possible...',
    rows: 4,
    snippets: true,
    generate: true,
    typeahead: true,
  })
  .transform(safify)
